import { render, staticRenderFns } from "./amount_table.vue?vue&type=template&id=437dc10c&"
import script from "./amount_table.vue?vue&type=script&lang=js&"
export * from "./amount_table.vue?vue&type=script&lang=js&"
import style0 from "./amount_table.vue?vue&type=style&index=0&id=437dc10c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports